




function menuMobile() {

    if (jQuery(".icmb-tpl-s1").length) {

        var menuIcon = ".icmb-tpl-s1";
        var mainHeader = ".header-tpl-s1";
        var headerActive = "hmbropen-m7";
        var collapseMenu = ".menuctn-s1";
        var menuCollapseActivated = "active-js";
        var body = "body";
        var bodyFixer = "fixer-s1";

        jQuery(menuIcon).on("click", function () {

            jQuery(collapseMenu).toggleClass(menuCollapseActivated);
            jQuery(mainHeader).toggleClass(headerActive);
            jQuery(body).toggleClass(bodyFixer);

        })
    }
};




export {menuMobile};


